<nav class="menu">
  <ul class="menu__list">
    <li *ngFor="let item of navMenu" class="menu__item">
      <a
        routerLink="{{ menuRoutes[item[0]] }}"
        routerLinkActive="active"
        [routerLinkActiveOptions]="{ exact: true }"
        class="menu__link"
      >
        {{ item[1] }}
      </a>
    </li>
    <li class="menu__item" *ngIf="canActive">
      <a
        routerLink="textbook"
        routerLinkActive="active"
        [routerLinkActiveOptions]="{ exact: true }"
        class="menu__link"
      >
        Учебник
      </a>
    </li>
    <li class="menu__item" *ngIf="canActive">
      <a
        routerLink="statistics"
        routerLinkActive="active"
        [routerLinkActiveOptions]="{ exact: true }"
        class="menu__link"
      >
        Статистика
      </a>
    </li>
  </ul>
</nav>
